










































































import {
  defineNuxtComponent,
  ref,
  useRouter,
  computed
} from '~/utils/nuxt3-migration'
import CNewBadge from '~/components/shared/configurable/badge/CNewBadge.vue'
import CMenuItem from '~/components/shared/configurable/menu/CMenuItem.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useDeps } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import RouteGuardService from '~/services/RouteGuardService'
import { NavigationLink, NavigationMenu } from '~/models/header/navigation-menu'
import { CategoryId } from '~/models/category/types'
import { AccessToggleName } from '~/models/user/access-toggles'
import { defineComponentTranslations } from '~/utils/i18n'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
import { ciVehicles } from '~/icons/source/thin/vehicles'
import { ciBoats } from '~/icons/source/thin/boats'
import { ciPartsAccessories } from '~/icons/source/thin/parts-accessories'
import { ciWantedParts } from '~/icons/source/thin/wanted-parts'
import { ciRentals } from '~/icons/source/thin/rentals'
import { ciMarketplace } from '~/icons/source/thin/marketplace'
import { ciRealEstate } from '~/icons/source/thin/real-estate'
import { ciJobs } from '~/icons/source/thin/jobs'
import { ciDeals } from '~/icons/source/thin/deals'
import { ciMagnifyingGlass } from '~/icons/source/thin/magnifying-glass'
import { ciCars } from '~/icons/source/thin/cars'
import { ciMotorbikes } from '~/icons/source/thin/motorbikes'
import { ciTrucks } from '~/icons/source/thin/trucks'
import { ciCaravans } from '~/icons/source/thin/caravans'
import { ciBicycles } from '~/icons/source/thin/bicycles'
import { ciHobbies } from '~/icons/source/thin/hobbies'
import { ciStar } from '~/icons/source/thin/star'
import { ciAdvertise } from '~/icons/source/thin/advertise'
import { ciAuditRequest } from '~/icons/source/thin/audit-request'
import { ciSaleRequest } from '~/icons/source/thin/sale-request'
import { ciExchange } from '~/icons/source/thin/exchange'
import { ciCalculator } from '~/icons/source/thin/calculator'
import { ciComments } from '~/icons/source/thin/comments'
import { ciCatalogue } from '~/icons/source/thin/catalogue'
import { ciPriceStatistics } from '~/icons/source/thin/price-statistics'
import { ciCarService } from '~/icons/source/thin/car-service'
import { ciPolygon } from '~/icons/source/thin/polygon'

export default defineNuxtComponent({
  components: {
    CMenuItem,
    CNewBadge,
    CIcon,
    CExternalLinkMediatorModal
  },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const [legacyUrlService, routeGuardService] = useDeps(
      LegacyUrlService,
      RouteGuardService
    )
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')
    const userRegisterLink = legacyUrlService.getRegisterUrl()

    const userIsManager = computed(() => userGetters('isManager'))

    const externalLinkMediatorUrl = ref('')
    const showExternalLinkMediatorModal = ref(false)
    const activeDropdown = ref<number | null>(null)
    const menu: NavigationMenu[] = [
      {
        title: t('search'),
        name: 'search',
        links: [
          [
            {
              title: t('vehicles'),
              icon: ciVehicles,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'vehicles', category: 'cars' }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('boats'),
              icon: ciBoats,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'boats' }
              }).href,
              useNuxtLink: true
            },
            {
              title: `${t('parts')} & ${t('accessories')}`,
              icon: ciPartsAccessories,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'parts', category: 'for-cars' }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('rentals'),
              icon: ciRentals,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'rentals' }
              }).href,
              useNuxtLink: true,
              isRentals: true
            },
            {
              title: t('classifieds::xyma'),
              icon: ciMarketplace,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'xyma' }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('real estate'),
              icon: ciRealEstate,
              url: router.resolve({
                name: '__classifieds_quick_search',
                params: { root: 'plot' }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('jobs'),
              icon: ciJobs,
              url: router.resolve({ name: '__classifieds_search_jobs' }).href,
              useNuxtLink: true
            },
            {
              title: t('deals'),
              icon: ciDeals,
              url: router.resolve({ name: '__classifieds_search_deals' }).href,
              useNuxtLink: true
            },
            {
              title: t('wanted_parts'),
              icon: ciWantedParts,
              url: router.resolve({
                name: '__classifieds_search_wanted_parts'
              }).href,
              useNuxtLink: true,
              useAnonGuard: true,
              hide: !userHasAccessTo(AccessToggleName.WANTED_PARTS_ACCESS)
            },
            {
              title: t('search classified with id'),
              icon: ciMagnifyingGlass,
              url: router.resolve({ name: '__search_classified_by_id' }).href,
              useNuxtLink: true
            }
          ]
        ],
        dropdownPosition: 'center'
      },
      {
        title: t('offer'),
        name: 'offer',
        links: [
          [
            {
              title: t('car::vehicles'),
              icon: ciCars,
              url: '/classifieds/cars/new/',
              useNuxtLink: false,
              useAnonGuard: true
            },
            {
              title: t('bike::vehicles'),
              icon: ciMotorbikes,
              url: '/classifieds/bikes/new/',
              useNuxtLink: false,
              useAnonGuard: true
            },
            {
              title: t('commercial::vehicles'),
              icon: ciTrucks,
              url: '/classifieds/commercial/new/',
              useNuxtLink: true,
              useAnonGuard: true
            },
            {
              title: t('camper::vehicles'),
              icon: ciCaravans,
              url: '/classifieds/camper/new/',
              useNuxtLink: true,
              useAnonGuard: true
            },
            {
              title: t('boat::vehicles'),
              icon: ciBoats,
              url: router.resolve({
                name: '__classifieds_boats_new_form',
                params: { categoryId: CategoryId.BOATS as string }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('bicycle::vehicles'),
              icon: ciBicycles,
              url: router.resolve({
                name: '__classifieds_bicycles_new_form',
                params: { categoryId: CategoryId.BICYCLES as string }
              }).href,
              useNuxtLink: true
            },
            {
              title: t('hobby::vehicles'),
              icon: ciHobbies,
              url: '/classifieds/hobby/new/',
              useNuxtLink: false,
              useAnonGuard: true
            }
          ],
          [
            {
              title: `${t('part')}/${t('accessory')}`,
              icon: ciPartsAccessories,
              url: router.resolve({
                name: '__classifieds_parts_new_form',
                params: { categoryId: CategoryId.PARTS as string }
              }).href,
              useNuxtLink: true,
              useAnonGuard: true
            },
            {
              title: t('wanted_parts'),
              icon: ciWantedParts,
              url: router.resolve({
                name: '__classifieds_wanted_parts_new_form',
                params: { categoryId: CategoryId.WANTED_PARTS as string }
              }).href,
              useNuxtLink: true,
              useAnonGuard: true,
              hide: !userHasAccessTo(AccessToggleName.WANTED_PARTS_ACCESS)
            },
            {
              title: t('rent'),
              icon: ciRentals,
              url: router.resolve({
                name: '__classifieds_rentals_new_form',
                params: { categoryId: CategoryId.RENTALS as string }
              }).href,
              useNuxtLink: true,
              isRentals: true
            },
            {
              title: `${t('real estate::akinito')} - Plot.gr`,
              icon: ciRealEstate,
              url: 'https://www.plot.gr/classifieds/new?vehuser=true',
              externalLink: true,
              useNuxtLink: false
            },
            {
              title: t('classified::xyma'),
              icon: ciMarketplace,
              url: router.resolve({
                name: '__classifieds_xyma_new_form',
                params: { categoryId: CategoryId.XYMA as string }
              }).href,
              useNuxtLink: true,
              useAnonGuard: true
            },
            {
              title: t('job'),
              icon: ciJobs,
              url: router.resolve({
                name: '__classifieds_jobs_new_form',
                params: { categoryId: CategoryId.JOBS as string }
              }).href,
              useNuxtLink: true
            }
          ]
        ],
        dropdownPosition: 'center',
        hide: !routeGuardService.userCanCreateClassified()
      },
      {
        title: t('services'),
        name: 'services',
        links: [
          [
            {
              title: t('classifieds promotion'),
              icon: ciStar,
              url: router.resolve({ name: '__landing_pages_promotions' }).href,
              useNuxtLink: true
            },
            {
              title: t('advertise at car'),
              url: '/advertising/',
              icon: ciAdvertise
            },
            {
              title: t('audits'),
              url: router.resolve({ name: '__landing_pages_audits' }).href,
              icon: ciAuditRequest,
              useNuxtLink: true
            },
            {
              title: t('car_service'),
              url: router.resolve({ name: '__vehicle_service_start' }).href,
              icon: ciCarService,
              useNuxtLink: true
            },
            {
              title: t('online_finance'),
              url: router.resolve({ name: '__landing_pages_finance' }).href,
              icon: ciCalculator,
              useNuxtLink: true
            },
            {
              title: t('wanted_parts'),
              url: router.resolve({ name: '__landing_pages_wanted_parts' })
                .href,
              icon: ciWantedParts,
              useNuxtLink: true
            },
            {
              title: t('extra_perk_packages'),
              url: router.resolve({ name: '__landing_pages_perks' }).href,
              icon: ciPolygon,
              useNuxtLink: true
            }
          ],
          [
            {
              title: t('buy_requests'),
              url: '/landing/sale-requests/',
              useNuxtLink: true,
              icon: ciSaleRequest,
              hide: !userIsManager.value
            },
            {
              title: 'Forum',
              url: router.resolve({ name: '__qna_view' }).href,
              icon: ciComments,
              useNuxtLink: true
            },
            {
              title: t('trades'),
              url: router.resolve({ name: '__trades' }).href,
              icon: ciExchange,
              useNuxtLink: true
            },
            {
              title: t('dealers catalogue'),
              url: '/dealers/',
              icon: ciCatalogue,
              useNuxtLink: true
            },
            {
              title: t('catalog of businesses'),
              url: '/cartalog/categories/',
              icon: ciCatalogue,
              useNuxtLink: false
            },
            {
              title: t('used car prices'),
              url: '/classifieds/cars/prices/',
              icon: ciPriceStatistics,
              useNuxtLink: false
            }
          ]
        ],
        dropdownPosition: 'center'
      },
      {
        title: t('information'),
        name: 'information',
        subtitles: [t('general'), t('dealers'), t('private sellers')],
        links: [
          [
            {
              title: t('support'),
              url: router.resolve({ name: '__information_contact' }).href,
              useNuxtLink: true
            },
            {
              title: t('market guide'),
              url: router.resolve({ name: '__information_market_guide' }).href,
              useNuxtLink: true
            },
            {
              title: t('terms and conditions'),
              url: router.resolve({ name: '__information_terms' }).href,
              useNuxtLink: true
            },
            {
              title: t('privacy policy'),
              url: router.resolve({ name: '__information_privacy' }).href,
              useNuxtLink: true
            },
            {
              title: t('job offers'),
              url: router.resolve({ name: '__information_careers' }).href,
              useNuxtLink: true
            },
            {
              title: 'Blog - Car.gr',
              url: 'https://blog.car.gr/',
              useNuxtLink: false
            }
          ],
          [
            {
              title: t('dealer registration'),
              url: router.resolve({ name: '__managers_register' }).href,
              useNuxtLink: true
            },
            {
              title: t('register your business'),
              url: '/cartalog/register/',
              useNuxtLink: false
            },
            {
              title: t('dealers frequently asked questions'),
              url: router.resolve({ name: '__information_dealers_faq' }).href,
              useNuxtLink: true
            }
          ],
          [
            {
              title: t('free user registration'),
              url: userRegisterLink,
              useNuxtLink: false
            },
            {
              title: t('users frequently asked questions'),
              url: router.resolve({ name: '__information_users_faq' }).href,
              useNuxtLink: true
            }
          ]
        ],
        dropdownPosition: 'center'
      }
    ]

    function toggleDropdown(key: number) {
      activeDropdown.value = activeDropdown.value === key ? null : key
    }

    function handleItemClick(link: NavigationLink, event: Event) {
      activeDropdown.value = null

      // Handle external links with modal
      if (link.externalLink && event) {
        event.preventDefault()
        externalLinkMediatorUrl.value = link.url
        showExternalLinkMediatorModal.value = true
      }
    }

    return {
      menu,
      activeDropdown,
      externalLinkMediatorUrl,
      showExternalLinkMediatorModal,
      toggleDropdown,
      handleItemClick
    }
  },
  i18n: defineComponentTranslations({
    general: {
      en: 'General',
      el: 'Γενικά'
    }
  })
})
